import { render } from "./SearchPages.vue?vue&type=template&id=56b980c2&scoped=true"
import script from "./SearchPages.vue?vue&type=script&lang=js"
export * from "./SearchPages.vue?vue&type=script&lang=js"

import "./SearchPages.vue?vue&type=style&index=0&id=56b980c2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b980c2"]])

export default __exports__